import store from '../store/store';
import Vue from 'vue';
import axios from 'axios';
import {Toast} from 'mint-ui';
import {MessageBox} from 'mint-ui';
import {GameData} from '../store/GameData';
import audioPlayer from '../utils/AudioPlayer';
import {HttpRequest} from '../store/HttpRequest';
import {ProjectData} from '../store/ProjectData';

window.iboxGoBack = function () {
  // iOS自定义关闭事件
  Methods.messageConfirm('', '确认退出吗？', '确认', '取消', function () {
    window.webkit.messageHandlers.iOSWKMethod.postMessage({
      key: "goBack",
      data: {},
      callBack: ""
    });
  }, null)
};

class CdnLibrary {
}

if (location.href.indexOf('test-') > -1) {
  CdnLibrary.TEST = true;
} else {
  CdnLibrary.TEST = false;
}

if (CdnLibrary.TEST) {
  CdnLibrary.DLCDN1 = '//testcdn.66rpg.com';
  store.state.manID = 1;
  store.state.womanID = 2;
  CdnLibrary.CG = "//test-cg.66rpg.com";
  CdnLibrary.WWW = "//test-www.66rpg.com";
  CdnLibrary.WCDN1 = "//wcdn1.cgyouxi.com";
  CdnLibrary.PIC = "//pic.cgyouxi.com";
} else {
  CdnLibrary.DLCDN1 = '//dlcdn1.cgyouxi.com';
  store.state.manID = 1;
  store.state.womanID = 2;
  CdnLibrary.CG = "//cg.66rpg.com";
  CdnLibrary.WWW = "//www.66rpg.com";
  CdnLibrary.WCDN1 = "//wcdn1.cgyouxi.com";
  CdnLibrary.PIC = "//pic.cgyouxi.com";
}

CdnLibrary.CDNRES = CdnLibrary.DLCDN1 + "/shareres/";

/*CdnLibrary.CG = "//local-cg.66rpg.com";
CdnLibrary.WWW = "//lightorange-test-www.66rpg.com";*/

CdnLibrary.request = {
  GET_CATEGORY_LISTS: CdnLibrary.WWW + '/LightOrange/tool/v1/category/get_category_lists',
  GET_GOODS_LISTS: CdnLibrary.WWW + '/LightOrange/tool/v1/goods/get_goods_lists',
  GET_GOODS_DETAILS: CdnLibrary.WWW + '/LightOrange/tool/v1/goods/get_goods_details',
  GET_PROJECT_LG: CdnLibrary.CG + '/interapi/project/v1/list/get_project_lg',
  UPLOAD_IMAGE: CdnLibrary.CG + '/pkg/upload_image/upload_pic_new',
  O_PROJ_CREATE: CdnLibrary.WWW + '/api/o_proj_create.php',
  GET_GAME_VERSION: CdnLibrary.CG + '/pkg/game/get_game_version',
  ABOX_UPDATE_IMAGE: CdnLibrary.CG + '/interapi/project/v1/file/android_upload_image_lg'
};

class ComponentName {
}

//todo  组件名-用于各子组件show/hide切换
ComponentName.START = "start";
ComponentName.PUTTERN = "pattern";
ComponentName.ROLE_LIST = "roleList";
ComponentName.STORY_MENU = "storyMenu";
ComponentName.STORYS_LIST = "storysList";
ComponentName.EDIT_STORY = "editStory";
ComponentName.CHAPTER_LIST = "chapterList";
ComponentName.CHAPTER_SET = "chapterset";
ComponentName.CHANGE_CHAPTER = "changeChapter";
ComponentName.CREATE_ROLE = "createRole";
ComponentName.ISSUS_SUCCESS = "issueSuccess";
ComponentName.IMAGE_LIBRARY = "imageLibrary";
ComponentName.MUSIC_LIBRARY = "musicLibrary";
ComponentName.CREATEION_TYPE = "creationType";
ComponentName.EDIT_STORY_ROLE = "editStoryRole";
ComponentName.EDIT_STORY_TEXT = "editStoryText";
ComponentName.CREATE_STORY_WIN = "createStoryWin";
ComponentName.ADJUSTMENT_POPUP = "adjustmentPopup";
ComponentName.ROLE_PIC_MATERIAL = "rolePicMaterial";
ComponentName.IMAGE_PREVIEW = "imageLibraryPreview";
ComponentName.EDIT_TEXT = "editText";
ComponentName.ADD_TAG = "addTag";


class Methods {
}

Methods.publishGame = function () {
  Methods.cutComponent([ComponentName.ISSUS_SUCCESS], true);
  // Middle.ServerPort.publishGame(1, this.publishGameRes, this)
};

Methods.setRoleSite = function () {
  var _store = store.state, _charId = _store.useRole ? _store.useRole.charId : null;

  store.state.setRoleSiteDom = false;
  if (_store.parrent.createPattern === 2) {
    if (_charId !== null && _charId > 0) {
      let _characterType = Middle.MiddleData.GetCharacter(_charId).characterType;

      if (!(_characterType === Methods.getRoleStatus('main'))) {
        store.state.roleSite = Middle.MiddleData.GetCharacterLastPos(_charId);

        if (store.state.roleSite !== 2) {
          if (store.state.roleSite < 0 || store.state.roleSite > 2) {
            store.state.roleSite = 0;
          }
          store.state.setRoleSiteDom = true;
        }
      }
    } else {
      store.state.roleSite = 2;
    }
  }
};

Methods.quietlySaveStory = function () {
  new ProjectData(this).saveStory(function () {
  }, this);
};

Methods.getUrlParam = function (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg);  //匹配目标参数
  if (r != null) return unescape(r[2]);
  return ''; //返回参数值
};

class OrgUser {
};
OrgUser.GetClientType = function () {
  return 0;
};

OrgUser.GetLoginToken = function () {
  if (window.org_box || location.href.indexOf('mark=wx') > -1) {
    return Methods.getUrlParam('token');
  }
  if (window.iOSinfo) {
    return window.iOSinfo.token;
  }
  return '';
};

OrgUser.GetUid = function () {
  if (window.org_box || location.href.indexOf('mark=wx') > -1) {
    return Methods.getUrlParam('uid');
  }
  if (window.iOSinfo) {
    return window.iOSinfo.uid;
  }
  return ssoLogin.user.uid
};

OrgUser.GetToken = function () {
  if (window.org_box) {
    return window.org_box.GetUid();
  }
  if (location.href.indexOf('mark=wx') > -1) {
    return Methods.getUrlParam('uid');
  }
  if (window.iOSinfo) {
    return window.iOSinfo.uid;
  }
  return ssoLogin.user.uid
};

OrgUser.GetUname = function () {
  if (window.org_box) {
    return Methods.getUrlParam('uname');
  }
  if (window.iOSinfo) {
    return window.iOSinfo.uname;
  }
  return ssoLogin.user.uname;
};

OrgUser.getPlat = function () {
  if (window.org_box) {
    return "aBox";
  }
  if (window.iOSinfo) {
    return "iBox"
  }
  if (location.href.indexOf('mark=wx') > -1) {
    return "wx"
  }
  return "h5"
};

window.orgUser = OrgUser;

Methods.cutComponent = function (name, b, caller, call) {
  // 组件show/hide切换
  let items = null;

  if (name === 'all') {
    let _componentList = [];

    for (let i in ComponentName) {
      if (!store.state.closeEditStory && ComponentName[i] === 'editStory') {
        store.state.hideEditStory = true;
      } else {
        _componentList.push(ComponentName[i]);
      }
    }

    items = _componentList;
    store.state.closeEditStory = false;
  } else {
    items = name
  }
  for (let i in items) {
    store.commit('cutModuleState', {name: items[i], b, call, caller});
  }
  checkData.updateAll();

};

Methods.roleNameProcess = function (name) {
  if (name.length > 8) {
    name = name.substring(0, 8) + '';
  }
  return name;
};

Methods.chapterJump = function (i) {
  // 章节跳转
  if (store.state.parrent.createPattern !== 0) {
    Middle.MiddleData.AddEvent([i]);
  }
  Middle.MiddleCommand.enterChapter(i);
  store.state.parrent.createPattern = Middle.ProjectData.chapter.values()[i].mode;
  store.commit('editStorySetout');
};

Methods.exitEditor = function () {
  StorageData.instance.destoryData();
  Middle.MiddleCommand.exitEditor();
};

Methods.canvasOut = function () {
  Middle.MiddleCommand.CanvasOut();
};

Methods.removeChapter = function (i, id) {
  // 删除章节

  let _index = null;

  if (Middle.ProjectData.chapter.values().length <= 1) {
    return Toast({
      message: '当前为最后一章'
    });
  }
  if (Middle.EditData.chapter === i) {
    _index = i > 0 ? i - 1 : i + 1;
    store.state.editChapter = _index;
    GameData.enterChapter(_index);
  }
  Middle.MiddleData.DeleteChapter(i);
  store.commit('editStorySetout');
};

Methods.changeChapterName = function (i, n) {
  // 修改章节名称
  Middle.ProjectData.chapter.values()[i].name = n;

   checkData.updateChapterHash();
   checkData.updateDifChapterHash();
   checkData.setDataHashCode(Middle.ProjectData.chapter.values()[i].id,Middle.ProjectData.chapter.values()[i]);
   checkData.setDataHashCode(GloableStaticData.CHAPTER_LIST_DATA_ID,Middle.ProjectData.chapter);
   checkData.setDataHashCode(GloableStaticData.CHAPTER_DIF_LIST_DATA_ID,Middle.ProjectData.difChapter);


  store.commit('editStorySetout');
};

Methods.getMalibClassify = function (item) {
  return item.name === '古代' ? 'ageOld' : 'modern';
};

Methods.checkUserReal = function () {
  // 实名制判断
  var res = false;

  axios.get({url: CdnLibrary.WWW + '/ajax/curpon/check_user_real.json', withCredentials: true})
    .then(function (res) {
      let _status = parseInt(res.status);

      if (_status > 0) {
        res = true;
      }
    })
    .catch(function (res) {
      alert('请求失败，请稍候重试');
    });
  return res;
};

Methods.multimediaReset = function () {
  // 关闭音乐
  audioPlayer.close();
};
Methods.addChapter = function (b, backPage) {
  // 添加章节 parm:true添加章节/false新建章节
  Methods.cutComponent('all', false);
  Methods.setHeaderConf('chapterSet', '编辑故事', backPage);
  store.state.isAddChapter = b;
  Methods.cutComponent([ComponentName.CHAPTER_SET], true);
};
Methods.clearStageRoleSign = function () {
  // 重置章节登场角色标记
  store.state.storyRoles.forEach(function (role) {
    // Vue.set(role, 'newMain', false);
    Vue.set(role, 'act', false);
    Vue.set(role, 'status', false);
    Vue.set(role, 'stage', false);
    store.commit('editStorySetout');
  });
  store.state.isChangeChapter = false;
  store.state.stageRoles = {status: '', main: [], costar: []};
  store.state.chapterSet = {bgSrc: '', bgName: '', musicSrc: '', musicName: ''};

  store.state.chapterConfig = {bg: null, bgm: null};
};

Methods.uploadStoryCover = function (file, callback, reader) {
  var _this = this, _token = window.orgUser.GetLoginToken(), _form = new FormData(),
    _guid = Methods.getGuid(), errNote = '上传封面失败，请重新上传', _withCredentials = false, maxUpdateSum = 0;

  var data = {
    guid: _guid,
    token: _token,
    source: 2
  };
  if (window.orgUser.getPlat() === "h5") {
    data.cookie = 1;
    _form.append('cookie', 1);
    _withCredentials = true;
  }

  _this.$http({
    url: CdnLibrary.request.GET_GAME_VERSION + '?v=' + new Date().getTime(),
    withCredentials: _withCredentials,
    params: data
  }).then(function (res) {
    if (parseInt(res.data.ret) !== 1) {
      _this.publishLock = false;
      return Toast({
        message: errNote
      });
    }
    let _ver = parseInt(res.data.data.version);

    Middle.ProjectData.header.version = _ver;
    _ver += 1;
    if (file === '') {
      _form.append('remote_url', Middle.ProjectData.header.cover);
    }

    _form.append('token', _token);
    _form.append('guid', _guid);
    _form.append('version', "2.4.3.0419");
    _form.append('cur_version', Middle.ProjectData.header.version + 1);
    _form.append('source', 2);
    _form.append('ver', _ver);
    _form.append('file', file);
    _form.append('upload_type', 'other');
    var uploadImage = function () {
      _this.$http.post(CdnLibrary.request.UPLOAD_IMAGE + '?v=' + new Date().getTime(), _form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: _withCredentials
      }).then(function (res) {
        if (parseInt(res.data.ret) !== 1) {
          _this.publishLock = false;
          return Toast({
            message: errNote
          });
        }
        // callback && callback();
        // return;
        var imgUrl = location.protocol + CdnLibrary.PIC + res.data.data.uri + '?v=' + new Date().getTime();
        setTimeout(() => {
          try {
            var ImgObj = new Image(); //判断图片是否存在

            ImgObj.src = imgUrl;

            if (ImgObj.complete) {
              callback && callback();
              return;
            }
            ImgObj.onload = function () {
              Middle.ProjectData.header.cover = imgUrl;

              if (reader) {
                store.state.storyCover = reader.result;
              }
              if (callback) {
                callback();
              }
            };

            ImgObj.onerror = function () {

              maxUpdateSum += 1;
              if (maxUpdateSum >= 2) {
                if (callback) {
                  callback();
                }
                return Toast({
                  message: errNote
                });
              }
              if (maxUpdateSum < 2) {
                try {
                  _form.set("remote_url", store.state.defCover);
                } catch (e) {
                  console.error(e);
                }
              }
              uploadImage();
            };
          } catch (e) {
          }
        }, 1000);
      }).catch(function (res) {
        _this.publishLock = false;
        return Toast({
          message: errNote
        });
      });
    };
    uploadImage();
  }).catch(function (res) {
    _this.publishLock = false;
    return Toast({
      message: errNote
    });
  });
};

Methods.saveStory = function (call, caller) {
  Middle.ProjectData.header.name = store.state.storyName;
  Middle.ServerPort.GetInstance().saveProject(this.saveStoryRes, this);
  call && call.call(caller);
};

Methods.storyLoading = function (res) {
  CanvasCommand.storyLoading(res);
};

Methods.saveStoryRes = function (res) {
  let _res = JSON.parse(res.target.response), _note = '';

  if (_res.ret === 1 && _res.code === 0) {
    _note = '保存成功';
    StorageData.instance.delLocalData();
  } else {
    _note = '保存失败';
  }
  Toast({
    message: _note
  });
};

Methods.copyArr = function (arr) {
  let res = [];
  for (let i = 0; i < arr.length; i++) {
    res.push(arr[i]);
  }
  return res;
};

Methods.getCategoryMd5 = function (category) {
  let _pics = [];

  for (let i = 0; i < category.length; i++) {
    let tailorSite = category[i].rs_url.lastIndexOf('/') + 1,
      endSite = category[i].rs_url.length;

    if (category[i].rs_url.indexOf('?v=') > -1) {
      endSite = category[i].rs_url.indexOf('?v=');
    }
    _pics.push(category[i].rs_url.substring(tailorSite, endSite));
  }
  return _pics;
};

Methods.getRoleCover = function (role) {
  let _covers = Middle.MiddleData.GetCharacter(role.id).src, _res = null;

  if (!Array.isArray(_covers)) {
    _covers = store.state.defaultRolePic;
  }
  _covers.forEach(function (name) {
    if (name.indexOf('_f_0') > -1) {
      _res = Middle.ResMap.getNameURL(name, true);
    }
  });
  return _res;
};

Methods.setHeaderConf = function (page, backNote, backPage) {
  store.state.nextPageHeaderConf[page] = {
    backNote: backNote,
    backPage: backPage
  }
};

Methods.addNumber = function (data) {
  Middle.MiddleData.addNumber(data);
};

/* todo 获取数据 */
Methods.boxVerJudge = function (type, ver) {
  var _res = false;

  if (type === 'abox') {
    if (org_box.getVer && org_box.getVer() > ver) {
      _res = true;
    }
  }
  if (type === 'ibox') {
    var nowVer = 0;

    if (window.iOSVer) {
      var nowVerSplit = [], startVerSplit = [];

      if (window.iOSVer.ver) {
        nowVer = window.iOSVer.ver;

        startVerSplit = ver.split('.');
        startVerSplit[2] = startVerSplit[2].length >= 4 ? 0 : startVerSplit[2];

        nowVerSplit = nowVer.split('.');
        nowVerSplit[2] = nowVerSplit[2].length >= 4 ? 0 : nowVerSplit[2];
        for (var i = 0; i < 3; i++) {
          if (parseInt(nowVerSplit[i]) > parseInt(startVerSplit[i])) {
            return _res = true;
          }
        }
      }
    }
  }
  return _res;
};

Methods.getGuid = function () {
  return Middle.ProjectData.header.guid;
};

Methods.getCharacter = function (id) {
  return Middle.MiddleData.GetCharacter(id);
};


Methods.getStoryStatus = function () {
  return Middle.ProjectData.header.status;
};

Methods.getStoryMode = function () {
  return Middle.ProjectData.header.projectMode;
};

Methods.getChapterVal = function (type, i) {
  let _res = null, _values = Middle.ProjectData.chapter._values;

  switch (type) {
    case 'length':
      _res = _values.length;
      break;
    case 'mode':
      _res = _values[i].mode;
      break;
    case 'nowChapter':
      _res = _values[Middle.EditData.chapter];
      break;
  }
  return _res;
};

Methods.getStoryAuditStatus = function (item) {
  let _level = item.check_level;

  if (_level === '' || _level === '-3') {
    return '未发布';
  }
  if (_level === '-2' || _level === '-1') {
    return '未过审';
  }
  if (_level === '0' || _level === '1') {
    return '待审核';
  }
  if (_level === '2') {
    return '已过审';
  }
};

/* todo 编辑角色 */
Methods.getRoleStatus = function (type) {
  // 获取角色地位
  let _res = null;

  switch (type) {
    case 'main':
      _res = GloableStaticData.CHARACTER_TYPE_MAIN;
      break;
    case 'costar':
      _res = GloableStaticData.CHARACTER_TYPE_OTHER;
      break;
    case 'sys':
      _res = GloableStaticData.CHARACTER_TYPE_SYS;
      break;
  }
  return _res;
};

Methods.openEditRoleView = function (type) {
  // 打开编辑角色页面
  Methods.cutComponent('all', false);
  if (type === 'init') {
    Methods.setHeaderConf('createRole', '角色列表', ComponentName.EDIT_STORY_ROLE);
  }
  Methods.cutComponent([ComponentName.CREATE_ROLE], true);
};

Methods.changRoleInfo = function (id) {
  // 修改角色信息
  let _charcater = Middle.MiddleData.GetCharacter(id);

  for (let i = 0; i < _charcater.src.length; i++) {
    _charcater.src[i] = _charcater.src[i].replace('half/', '');
  }

  store.state.createRole = {
    isChange: true,
    id: _charcater.id,
    name: _charcater.name,
    desc: _charcater.describe,
    gender: _charcater.sex,
    pic: '',
    coverName: _charcater.src,
    coverNameFull: _charcater.src,
    coverNameRs: null
  };
  Methods.openEditRoleView();
};

Methods.removeRole = function (id) {
  // 删除角色
  Middle.MiddleCommand.deleteCharacter(id);
};

Methods.stroryOutCharacter = function (id) {
  // 角色退场
  Middle.MiddleCommand.stroryOutCharacter(id)
};

Methods.canStoryOutCharacter = function (id) {
  // 获取角色会否可以退场
  if (store.state.isChangeChapter) {
    return Middle.MiddleCommand.canStoryOutCharacter(id);
  }
  return true;
};

Methods.getNameURL = function (conf) {
  // 获取角色资源
  return Middle.ResMap.getNameURL(conf);
};

Methods.getCharacter = function (id) {
  // 获取角色信息
  return Middle.MiddleData.GetCharacter(id);
};

Methods.storyDesc = function () {
  // 获取简介
  return Middle.ProjectData.header.description;
};

Methods.getCharacterExpression = function (charId) {
  // 获取角色表情
  return Middle.MiddleData.getCharacterExpression(charId)
};

/* todo 功能实现 */
Methods.openMaLib = function (maLibType, openType, callback) {
  Methods.cutComponent([maLibType], true);
  store.state.openMaLibAffair = openType;
  if (openType === 'changeInsert') {
    store.state.openMaLibCallBack = callback;
  }
};


Methods.appShare = function (previewSrc) {
  var cover = store.state.storyCover, title = store.state.storyName, reg = '&mark=light',
    subtitle = '哈喽！我发布了轻橙作品，邀请你来观看～', gameUrl = location.protocol + previewSrc;

  Methods.checkChapterHash(52);
  gameUrl = gameUrl.replace('&mark=ios_light', reg).replace('&mark=android_light', reg);
  if (window.iOSinfo) {
    window.webkit.messageHandlers.iOSWKMethod.postMessage({
      key: "openShareWindow",
      data: {
        cover,
        title,
        subtitle,
        gameUrl
      },
      callBack: "iBoxShareCallBack"
    });
  } else if (window.org_box && window.org_box.shareGameStory) {
    window.org_box.shareGameStory(gameUrl, title, cover, subtitle);
  }
};

Methods.getUpdateVer = function (call, caller) {
  let _this = caller, _token = window.orgUser.GetLoginToken(), _guid = Methods.getGuid(),

    errNote = '上传封面失败，请重新上传', _withCredentials = false;

  let data = {
    guid: _guid,
    token: _token,
    source: 2
  };

  if (window.orgUser.getPlat() === "h5") {
    data.cookie = 1;
    _withCredentials = true;
  }

  _this.$http({
    url: CdnLibrary.request.GET_GAME_VERSION + '?v=' + new Date().getTime(),
    withCredentials: _withCredentials,
    params: data
  })
    .then(function (res) {
      if (parseInt(res.data.ret) !== 1) {
        return Toast({
          message: errNote
        });
      }
      let _ver = parseInt(res.data.data.version);

      _ver = _ver <= 0 ? 1 : _ver;
      Middle.ProjectData.header.version = _ver;

      call && call(_ver);
    })
    .catch(function (res) {
      return Toast({
        message: errNote
      });
    });
};

Methods.messageConfirm = function (title, slogan, confirmBtnText, cancelBtnText, thenCall, catchCall) {
  // mintUI-Confirm
  MessageBox.confirm(slogan, title, {
    confirmButtonText: confirmBtnText,
    cancelButtonText: cancelBtnText
  }).then(() => {
    thenCall && thenCall();
  }).catch(() => {
    catchCall && catchCall();
  });
};

Methods.checkChapterHash = function(type) {
  checkData.checkChapterHash(type);
};


Methods.messageAlert = function (title, slogan, call) {
  // mintUI-alert
  MessageBox.alert(slogan, title)
    .then(() => {
      call && call();
    })
};

Methods.clearUseRole = function () {
  store.state.useRole = {cover: null, name: "", mood: 'normal'};
};

Methods.initialChapterJump = function (res) {
  // 章节跳转
  GameData.enterChapter(res);
  store.state.parrent.createPattern = Methods.getChapterVal('mode', res);
  store.commit('editStorySetout');
};

Methods.sendTextMsg = function (type, msg, item) {
  // 发送消息
  let _store = store.state, useRole = store.state.useRole, t_type = 2,
    createPattern = _store.parrent.createPattern;

  if (useRole.name === '') {
    return Toast({
      message: '请选择登场角色'
    });
  }
  if (_store.editMsgText === '' && type === 'txt') {
    return Toast({
      message: '内容不能为空'
    });
  }
  let _mood = '', _site = '';

  if (createPattern !== 0) {
    _mood = useRole.mood;
  }
  // if (createPattern === 2) {
  if (_store.roleSite == -1) {
    _store.roleSite = Middle.MiddleData.GetCharacterLastPos(useRole.charId)
  }
  _site = createPattern === 2 ? _store.roleSite : '';
  //   debugger
  //   _store.setRoleSiteDom = false;
  // }
  _store.editMsgEmoji = false;

  switch (type) {
    case 'txt':
      //todo type: 0 | 1 | 2 = 0   文字 图片 音频
      t_type = 0;
      item = store.state.editMsgText;
      break;
    case 'emoji':
      t_type = 1;
      break;
  }
  GameData.AddText(useRole.charId, item, _mood, t_type, _site);

  if (createPattern === 2) {
    _store.roleSite = -1;
    _store.setRoleSiteDom = false;
  }
  _store.sendMesCount += 1;

  var projectData = new ProjectData(this);

  projectData.saveStory(function (res) {
    let _res = JSON.parse(res.target.response);

    if (_res.ret === 1 && _res.code === 0) {
      if (store.state.sendMesCount % 9 === 0) {
        Methods.cutComponent(['autoSave'], true);

        clearTimeout(store.state.autoSaveTimer);
        store.state.autoSaveTimer = setTimeout(function () {
          Methods.cutComponent(['autoSave'], false);
        }, 3500);
      }
    }
  }, this);
  if (t_type === 0) {
    Middle.MiddleCommand.cancelEdit();
  }
};

Methods.addInitDifItem = function () {


}

/* todo canvas-Vue交互 */
class CanvasCommand {
}

CanvasCommand.saSend = function (type, msg) {
  // 统计
  try {
    msg.etype = 4;
    msg.type = type;
    Object.assign(msg, {uid: OrgUser.GetToken()});
    sa.track('DoSomething', msg);
  } catch (e) {
    console.error(e);
  }
};

CanvasCommand.editText = function (pos) {
  // 编辑文本
  let _store = store.state;

  if (pos !== '') {
    let story = GloableData.getInstance().editorData.story[pos],
      roleConf = Methods.getCharacter(story.characterId),
      cover = Methods.getNameURL(roleConf.src[0]);

    _store.useRole = {charId: roleConf.id, cover: cover, name: roleConf.name, mood: story.emotion};

    if (story.type === 1) {
      _store.editMsgEmoji = true;
    } else {
      _store.editMsgText = story.text;
      _store.editText = true;
      Methods.setRoleSite();
    }
  } else {
    _store.editText = true;
  }
};

CanvasCommand.cancelEdit = function () {
  let editStoryInput = document.getElementById('editStoryInput');

  store.state.isShortcutInit = true;
  store.state.editMsgText = '';
  store.state.editText = false;
  editStoryInput.blur();
};

CanvasCommand.guide = function (res) {
  store.state.guide = res;
};

CanvasCommand.tips = function (msg) {
  Toast({
    message: msg
  });
};

CanvasCommand.errorToast = function (msg) {
  Toast({
    message: msg
  });
  store.state.publishLoading = false;
  /*if (isPublish) {
    store.state.
  }*/
};

CanvasCommand.storyLoading = function (res) {
  Methods.cutComponent(['isStoryLoading'], res);
};

CanvasCommand.closeSetTag = function () {
  store.state.moduleState.addTag = false;
};

CanvasCommand.messageConfirm = Methods.messageConfirm;

CanvasCommand.lastDialogue = function () {
  MessageBox.confirm('当前为最后一条，是否编辑新对话', '',)
    .then(() => {
      // var _storyInfo = Middle.ProjectData.chapter.values()[Middle.EditData.chapter].story,
      var _storyInfo = GloableData.getInstance().editorData.story,
        _roleInfo = Middle.MiddleData.GetCharacter(_storyInfo[_storyInfo.length - 1].characterId);
      if (!_roleInfo) {
        _roleInfo = Middle.MiddleData.GetCharacter(Middle.MiddleCommand.getLastTextData(_storyInfo.length - 1).characterId);
      }
      store.state.useRole = {
        charId: _roleInfo.id,
        name: _roleInfo.name,
        cover: Middle.ResMap.getNameURL(_roleInfo.src[0]),
        mood: _storyInfo[_storyInfo.length - 1].emotion
      };
      // alert(3)
      Methods.cutComponent([ComponentName.EDIT_STORY_TEXT], true);
      store.state.visualEdit = false;
    }).catch(() => {
    // alert(2)
  });
};

CanvasCommand.openAdjustment = function (items) {
  store.state.adjustmentItems = items;
  Methods.cutComponent([ComponentName.ADJUSTMENT_POPUP], true);
};

CanvasCommand.editConditions = function () {
  store.state.conditionsType = 'edit';
  store.state.conditionsSwitch = true;
};

CanvasCommand.shortcutInit = function () {
};
CanvasCommand.setTextEditOut = function () {
  store.state.editText = false;
  store.state.setRoleSiteDom = false;
  store.state.parrent.createPattern = GloableData.getInstance().editorData.mode;
  store.commit('editStorySetout');
}

CanvasCommand.messageBox = Methods.messageBox;
CanvasCommand.httpCanvasRequest = HttpRequest.httpCanvasRequest;

export {ComponentName, Methods, CdnLibrary, CanvasCommand}



// WEBPACK FOOTER //
// ./src/const/common.js